import { RefObject, useCallback, useEffect, useState } from 'react';

export const useIntersecting = ({
  domNode,
  callback,
  rootMargin = '400px',
  ratio = 0,
  stayActive = false,
}: {
  domNode?: HTMLElement | null;
  rootMargin?: string;
  callback?: () => HTMLElement | null;
  ratio?: number;
  stayActive?: boolean;
}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const handleIntersection: IntersectionObserverCallback = useCallback(
    (entries, observer) => {
      const [entry] = entries;
      const isEntryIntersecting = entry.intersectionRatio > (ratio == 1.0 ? 0.99 : ratio);

      setIsIntersecting(isEntryIntersecting);

      if (!stayActive && isEntryIntersecting) {
        observer.disconnect();
      }
    },
    [ratio, stayActive],
  );

  useEffect(() => {
    const element = callback?.();
    if (!element) return;

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin,
      threshold: ratio,
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [domNode, rootMargin, ratio, stayActive, callback, handleIntersection]);

  return [isIntersecting];
};
